<div class="busy-indicator-container">
    <mat-spinner class="busy-indicator" [diameter]="diameter"></mat-spinner>
</div>